import { render, staticRenderFns } from "./kcOrder.vue?vue&type=template&id=573dec03&scoped=true&"
import script from "./kcOrder.vue?vue&type=script&lang=js&"
export * from "./kcOrder.vue?vue&type=script&lang=js&"
import style0 from "./kcOrder.vue?vue&type=style&index=0&id=573dec03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573dec03",
  null
  
)

export default component.exports